import { useState, useContext, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";


import { useFormikContext } from "formik";
import { ClienteContext } from "../../contexts/clientes-context";
import { GrDeliver } from "react-icons/gr";
import SearchListMunicipios from "../searchs_comp/search-List.Municipios";
import EditControl from "../controls_comp/control-edit";
import EditCpfCnpjControl from "../controls_comp/control-edit-cpf-cnpj";
import EditFoneControl from "../controls_comp/control-edit-fone";
import EditCepControl from "../controls_comp/control-edit-cep";
import ModalMapControl from "../ui_comp/Modals/ModalMap";

export default function ClienteTabEnderecoEntrega() {
  const {
    constantes,
    handleLoad,
    camposDesabilitados,
    somenteLeitura,
    setModalMap,
    modalMap,
    updateLatitudeLongitudeEntrega,
    configuracoes
  } = useContext(ClienteContext);

  const [tipoPessoaSwitch, setTipoPessoaSwitch] = useState('Física');

  const { values, setFieldValue, setValues } = useFormikContext();

  const lat = values.LatitudeEntrega;
  const long = values.LongitudeEntrega;
  const county = values.MunicipioEntrega?.Nome
  const address = values?.EnderecoEntrega;
  const cep = values?.CepEntrega;
  const number = values?.NumeroEnderecoEntrega;
  const neighborhood = values?.BairroEntrega;

  const addressSearchLocation = `${address && `${address}`} ${number && `, ${number}`}${county && `, ${county}`}${cep && `, ${cep}`}${neighborhood && `, ${neighborhood}`}`;

  useEffect(() => {
    setTipoPessoaSwitch(values?.CpfCnpjEntrega.length > 11 ? 'Jurídica' : 'Física');
  }, [values?.CpfCnpjEntrega])

  return (
    <>
      <Box component={Paper}>
        <Box
          display="flex"
          alignItems="center"
          p={2}
          height={50}
          sx={{ backgroundColor: "rgba(59, 134, 124, 0.08)" }}
        >
          <Typography variant="h1" fontSize={22} fontWeight="sembold">
            <GrDeliver style={{ marginBottom: "5px", marginRight: "8px" }} />
            {constantes.EnderecodeEntrega}
          </Typography>
        </Box>

        <Grid container spacing={2} p={2}>
          <Grid
            spacing={2}
            container
            item
            xs={12}
            sm={12}
            md={12}
            display="flex"
            alignItems="end"
          >
            <Grid ml={2} xs={12} sm={3.6} md={4.2}>
              <EditCepControl
                disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
                name="CepEntrega"
                placeholder={constantes?.Cep}
                type="text"
                onCepResponse={(enderecoResponse, municipioResponse) => {
                  setValues({
                    ...values,
                    EnderecoEntrega: enderecoResponse.logradouro,
                    BairroEntrega: enderecoResponse.bairro,
                    MunicipioEntrega: municipioResponse
                  })
                }}
              />
            </Grid>
            <Grid item xs={12} sm={10} md={10}>
              <EditControl
                inputProps={{ maxLength: 50 }}
                disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
                name="EnderecoEntrega"
                placeholder={constantes?.Endereco}
                type="text" />
            </Grid>

            <Grid item xs={12} sm={5} md={5}>
              <EditControl
                inputProps={{ maxLength: 10 }}
                disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
                name="NumeroEnderecoEntrega"
                placeholder={constantes?.Numerodoendereco}
                type="text" />
            </Grid>
            <Grid item xs={12} sm={5} md={5}>
              <EditControl
                inputProps={{ maxLength: 50 }}
                disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
                name="ComplementoEnderecoEntrega"
                placeholder={constantes?.Complemento}
                type="text" />
            </Grid>
            <Grid item xs={12} sm={10} md={10}>
              <EditControl
                inputProps={{ maxLength: 50 }}
                disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
                name="BairroEntrega"
                placeholder={constantes?.Bairro}
                type="text" />
            </Grid>

            <Grid item xs={12} sm={10} md={10}>
              <SearchListMunicipios
                name="MunicipioEntrega"
                nameId="MunicipioEntrega.Id"
                nameDesc="MunicipioEntrega.Nome"
                placeholder={constantes.Municipio}
                disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
                onLoad={handleLoad}
                onItemSelected={(item) => {
                  setFieldValue("MunicipioEntrega", item);
                }}
                onItemClear={() => {
                  setFieldValue("MunicipioEntrega", {Id:0, Nome : ""});
                }}
              />
            </Grid>

          <Grid item xs={12} sm={5} mt={-0.6} md={3}>
            <EditControl
              disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
              name="LatitudeEntrega"
              placeholder={constantes?.Latitude}
              type="decimal"
              inputProps={{ step: "any", min: -90, max: 90, maxLength: 15 }}
            />
          </Grid>
          <Grid item xs={12} sm={5} mt={-0.6} md={3}>
            <EditControl
              disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
              name="LongitudeEntrega"
              placeholder={constantes?.Longitude}
              type="decimal"
              inputProps={{ step: "any", min: -90, max: 90, maxLength: 15 }}
            />
          </Grid>
          {configuracoes?.ChaveApiGoogleMaps &&

            <Grid item xs={12} sm={5} mt={-0.6} md={3}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  height: "100%",
                }}
              >
                <Button
                  bsPrefix="ButtonStyle BtnBuscar"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "0.4rem",
                    gap: 1,
                  }}
                  disabled={
                    somenteLeitura ||
                    camposDesabilitados.EnderecodeEntrega ||
                    !values.CepEntrega ||
                    !values.EnderecoEntrega ||
                    !values.MunicipioEntrega?.Id
                  }
                  onClick={() => setModalMap(true)}
                >
                  <PlaceIcon fontSize="small" />{" "}
                  <Typography sx={{ fontSize: 13, textAlign: "center" }}>
                    {" "}
                    {constantes?.SelecionarLocalizacao}{" "}
                  </Typography>
                </Button>
              </Box>
            </Grid>
            }

            <Grid item xs={12} sm={10} md={10}>
              <EditControl
                inputProps={{ maxLength: 50 }}
                disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
                name="NomeRecebEntrega"
                placeholder={constantes?.NomeRecebedor}
                type="text" />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={5} mt={-0.6} md={5}>
            <EditCpfCnpjControl
              tipoPessoa={tipoPessoaSwitch}
              inputProps={{ maxLength: 14 }}
              disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
              name="CpfCnpjEntrega"
              placeholder={constantes?.CpfCnpjCliente}
              type="text" />
          </Grid>

          <Grid item xs={12} sm={5} md={5}>
            <EditFoneControl
              inputProps={{ maxLength: 12 }}
              disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
              name="TelefoneEntrega"
              placeholder={constantes?.Telefone}
              type="text" />
          </Grid>
          <Grid item xs={12} sm={10} md={10}>
            <EditControl
              inputProps={{ maxLength: 100 }}
              disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
              name="EmailEntrega"
              placeholder={constantes?.Email}
              type="email" />
          </Grid>

          <Grid item xs={12} sm={10} md={10}>
            <EditControl
              inputProps={{ maxLength: 15 }}
              disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
              name="InscricaoEstadualEntrega"
              placeholder={constantes?.InscrEstadualProdutor}
              type="text" />
          </Grid>

          <Grid item xs={12} sm={10} md={10}>
            <EditControl
              inputProps={{ maxLength: 300 }}
              disabled={somenteLeitura || camposDesabilitados.EnderecodeEntrega}
              name="ObservacaoEntrega"
              placeholder={constantes?.ObservacaoEntrega}
              type="text" />
          </Grid>
        </Grid>
      </Box>

      {configuracoes?.ChaveApiGoogleMaps && 
      <ModalMapControl
          constantes={constantes}
          defaultValue={addressSearchLocation}
          markerAtual={
            lat && long
              ? {
                lat: lat,
                lng: long,
              }
              : null
          }
          onSelectedMarker={(marker) => {
            updateLatitudeLongitudeEntrega(
              Number(marker.lat.toFixed(6)),
              Number(marker.lng.toFixed(6)),
              setValues
            );
            setModalMap(false);
          }}
          modal={modalMap}
          toggle={(e) => setModalMap(false)}
      />
      }
    </>

  );
}
